import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import LogoSvg from './bc.svg';
import cn from './styles.module.scss';

export const LogoIcon = ({ variant = '', className = '', ...props}) => (
  <LogoSvg className={classNames(className, {[cn.filled]: variant === 'filled' })} {...props} />
);

LogoIcon.propTypes = {
  variant: PropTypes.oneOf(['filled']),
  className: PropTypes.string,
};
